import { render, staticRenderFns } from "./edit-applicant-form.vue?vue&type=template&id=57ad24f6"
import script from "./edit-applicant-form.vue?vue&type=script&lang=js"
export * from "./edit-applicant-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports